angular
	.module 'App.Directive.EpicConfiguration'
	.directive 'epicConfigurationItem',
		->
			restrict: 'EA';
			scope:
				selectedItem: '='
				modelName: '@'
				modelId: '@'
			controller: 'EpicConfigurationItemController'
			controllerAs: 'epicItem'
			bindToController: true
			templateUrl: "@directive/epic-configuration/epic-configuration.item.view.html"

class EpicConfigurationItemController extends AbstractController
	@register angular.module 'App.Directive.EpicConfiguration'
	@inject 'MessageTerminal',
		'ConfigurationService'
		'ConfigurationRepository'
		'ConfigurationValueRepository'
		'ToastService'
		'typeEnum': 'BACKEND_CONFIGURATION_ENTITY_TYPE'

	initialize: ->
		@ConfigurationValueRepository.setupContext(@modelName);

		@type = @ConfigurationValueRepository.type
		@saving = false
		@configsWithSaveButton = [
			@typeEnum.COLOR
			@typeEnum.STRING
			@typeEnum.ENCRYPTED_STRING
			@typeEnum.MULTILINE_STRING
			@typeEnum.INTEGER
			@typeEnum.FILE
			@typeEnum.FLOAT
			@typeEnum.ARRAY
		]

		@levels = [
			{
				type: 'ConfigurationValue'
				classType: 'primary'
				name: 'Default'
			}
			{
				type: 'MasterUserConfigurationValue'
				classType: 'warning'
				name: 'Master User'
			}
			{
				type: 'SystemModuleConfigurationValue'
				classType: 'danger'
				name: 'System Module'
			}
			{
				type: 'MerchantGroupConfigurationValue'
				classType: 'danger'
				name: 'Merchant Group'
			}
			{
				type: 'ShopConfigurationValue'
				classType: 'success'
				name: 'Shop'
			}
			{
				type: 'RoleConfigurationValue'
				classType: 'success'
				name: 'Role'
			}
			{
				type: 'UserConfigurationValue'
				classType: 'success'
				name: 'User'
			}
		]

	store: (configCategory) ->
		configCategory.saving = true

		@ConfigurationValueRepository
			.saveByContext configCategory.config, @modelName, @modelId
			.then (response) =>
				config = @ConfigurationValueRepository.convertConfigurationValueToConfiguration(
					response.data,
					@modelName,
					@modelId
				)

				newConfig = angular.extend({}, configCategory.config, config)

				@afterChange configCategory, newConfig
			.catch (response) =>
				@onError response, configCategory

	delete: (configCategory) ->
		configCategory.saving = true

		@ConfigurationValueRepository
			.delete(configCategory.config.id)
			.then =>
				@ConfigurationRepository
					.findByIdentifierInContext(@modelName, @modelId, configCategory.config.identifier)
					.then (response) =>
						@afterChange configCategory, response
					.catch (response) =>
						@onError response, configCategory
			.catch (deleteResponse) =>
				@onError deleteResponse, configCategory

	afterChange: (configCategory, newConfig) ->
		configCategory.config = newConfig
		configCategory.saving = false

		@ConfigurationService.set configCategory.config
		@MessageTerminal.publish @MessageTerminal.events.REFRESH

		@ConfigurationValueRepository.hideSensitiveInformation configCategory.config

	onError: (errorResponse, configCategory) ->
		configCategory.saving = false
		console.error errorResponse
		@ToastService.showErrors(errorResponse, configCategory.config.identifier)

	addArrayConfiguration: (configCategory) ->
		if _.isEmpty configCategory.config.itemValue
			return

		configCategory.config.values.push(configCategory.config.itemValue)
		configCategory.config.itemValue = null

	removeArrayConfiguration: (configCategory, index) ->
		configCategory.config.values.splice(index, 1)
